import { getBearerToken } from "../../../../api/postCall/bearerToken";
import {
  searchForMedicalPaOrdersFromPostgres,
  SearchForMedicalPaOrdersFromPostgresParams,
} from "../../../../api/postgreSQL/postCalls/searchForMedicalPaOrdersFromPostgres";
import { AuthStatusOptionModel } from "../../../../data-model/authStatusOptions";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";
import { ReviewPendingOrdersState } from "../hooks/useReviewPendingOrdersTableData";
import { generateReviewPendingOrdersTableDataFromAlgoliaRecords } from "../utils/generateTableDataFromAlgoliaRecords";

/**
 * Fetches review-pending orders from Postgres using the given search payload,
 * then updates the orders state and table data. Resets pagination on completion.
 *
 * @param payload - Search parameters for the Postgres query
 * @param authStatusOptions - Available auth status options for badge rendering
 * @param setReviewPendingOrdersState - State setter for the orders loading/data/error state
 * @param setTableData - State setter for the transformed table row data
 * @param setPaginationResetCount - Incremented to signal a pagination reset
 */
export const makePostCallForReviewPendingOrders = async (
  payload: SearchForMedicalPaOrdersFromPostgresParams,
  authStatusOptions: AuthStatusOptionModel[],
  setReviewPendingOrdersState: React.Dispatch<
    React.SetStateAction<ReviewPendingOrdersState>
  >,
  setTableData: React.Dispatch<
    React.SetStateAction<MyMedicalPaOrdersTableData[]>
  >,
  setPaginationResetCount: React.Dispatch<React.SetStateAction<number>>,
) => {
  setReviewPendingOrdersState((prev) => ({ ...prev, loading: true }));
  try {
    await getBearerToken();
    const response = await searchForMedicalPaOrdersFromPostgres(payload);
    const data: PostgresResponseForMedicalPaOrders = JSON.parse(
      response,
    ) as PostgresResponseForMedicalPaOrders;
    setReviewPendingOrdersState((prev) => ({
      ...prev,
      data: data,
    }));
    setTableData(
      generateReviewPendingOrdersTableDataFromAlgoliaRecords(
        data.hits ?? [],
        authStatusOptions,
      ),
    );
  } catch (error) {
    setReviewPendingOrdersState((prev) => ({
      ...prev,
      error: error as string,
    }));
  } finally {
    setReviewPendingOrdersState((prev) => ({ ...prev, loading: false }));
    setPaginationResetCount((prev) => prev + 1);
  }
};
